import Joi from "joi";

const instance = Joi.defaults((schema) =>
  schema.options({
    errors: { wrap: { label: " " } },
  })
);

export default instance;
